module.exports = __webpack_public_path__ + "img/portfolio-tech.bc26831b.png";